import { NgModule, Pipe } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { UtilAparelhoListaComponent } from './util-aparelho-lista.component';
import { SortByPipe } from '../../pipes/sort-by.pipe';

@NgModule({
  declarations: [
    UtilAparelhoListaComponent,
    SortByPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
  ],
  exports: [
    UtilAparelhoListaComponent,
    SortByPipe
  ],
})
export class UtilAparelhoListaModule { }
